import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-master-projects-image-grid',
  templateUrl: './master-projects-image-grid.component.html',
  styleUrls: ['./master-projects-image-grid.component.scss'],
  host: { class: 'master-projects-image-grid' },
})
export class SharedMasterProjectsImageGridComponent {
  @Input() projects!: any;
}
